// Mirrors PosMappingEntity.OrderType (API) — Unknown is intentionally omitted, use '' (empty) for general/any.
// This matches Orderly.Inventory.Functions.Pos.Processing.FileProcessors RawTransactions -> SaleOrderType
export enum PosMappingOrderType {
  EatIn = 1,
  TakeAway = 2,
  DriveThru = 3,
  Delivery = 4,
}
